import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/slick.js';
import 'plugs/jquery.mmenu.all.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';

var $window = $(window);
var $header = $('header nav');
var winW,winH,footerH,bodyH,scrollTop;
$(function() { 
    $('body').addClass('fade-in');    
    $("#topBtn").click(function() {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    ///mobile menu
    var menuicon = $('header .menuicon'),
    navBox = $('header .mmenu'),
    nav = $('header .navBox'),
    $body = $('body'),
    $header = $('header');
    menuicon.on('click',function(){
        // $('#nav-search').removeClass("is-open");
        $('.otherBox').slideUp();
        var $this = $(this);
        if(!$header.hasClass('menu-expanded')){
            $header.addClass('menu-expanded');
            nav.stop().fadeIn();
        }else{
            $header.removeClass('menu-expanded');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
        }
        return false;
    });
    $('a[data-menu]').on('click',function(){
        var $this = $(this);    
        if($this.next().is(':hidden')){
            $this.next().slideDown();
        }else{
            $this.next().slideUp();
        }            
    });
    $("input.headTarget").keypress(function(e){
        var code = (e.keyCode ? e.keyCode : e.which);        
        var kw = $(this).val();
        if (code == 13 && kw !=""){
            location.href = "search.php?kw="+kw;
        }
    });
    $("span.headTarget").on("click",function(e){
        var kw = $("#hdkw").val();
        if(kw){
            location.href = "search.php?kw="+kw;
        }
    });
    
    $window.on('resize',function(){
        winW = $window.width();
        winH =  $window.height();
        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;  
        //bodyH
        $('#Wapper').css('min-height',bodyH);
        if(winW > 991){
            $header.removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function(){$(this).removeAttr('style');});
            $body.css({'overflow':''});
        }
        resizeBgcover(winW);//background-image
    }).resize();    
    //scroll animation
    window.setTimeout(function(){
        $window.on('scroll', revealOnScroll);
        revealOnScroll();
    },800);
    $window.on('scroll', function() {
        scrollTop = $(this).scrollTop();
        gotopfun(scrollTop);
    }).scroll();
    // $('input[text="date"]').on('onchange',function(e) {
    //     alert(e.target.value);
    //   });
    $('[data-down]').on('click',function(){
        $header.removeClass('menu-expanded');
        nav.stop().fadeOut(function(){$(this).removeAttr('style');});
        var obj = $(this).data("down");
        var hidediv = $("#"+obj);
        if(hidediv.is(':hidden')){
            $('.otherBox:not(#'+obj+')').slideUp();
            hidediv.slideDown();
        }else{
            hidediv.slideUp();
        }
    });
    $('[data-toggle]').on('click',function(){
        var obj = $(this).index();
        var hidediv = $('#hdtxt');
        if(!$(this).hasClass('active')){
            $('[data-toggle]').removeClass('active');
            $(this).addClass('active');
            hidediv.children('div').fadeOut();
            hidediv.children('div').eq(obj).fadeIn();
        }
        return false;
    });
    $('.shbrand').on('click',function(){
        $('.brand-img').removeAttr('style');
    });
    $(".slider-banner").on("init", function(event, slick){
        if(slick.slideCount == 1){
            $('.slick-btn').hide();
        }
    });
    $('.slider-banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover:false,
        autoplay:true,
        autoplaySpeed:5000,
        speed:1500,
        fade:true,
        arrows: false,
        dots: false,
    });
    $('.btn-slick-prev').click(function(){
        $('.slider-banner').slick("slickPrev");
    });
    $('.btn-slick-next').click(function(){
        $('.slider-banner').slick("slickNext");
    });
    
    $('.slick-img').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplaySpeed:3000,
        infinite: true,
        speed:800,
        focusOnSelect: false,
        pauseOnHover:false,
        pauseOnFocus: false,
        autoplay:true,
        arrows:false,
        dots:false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                  slidesToShow: 1
                }
            },  
        ]
    });    
    var page,o_page;
    $('.temp-bg').on('mouseenter',function(){
        $(this).addClass('hover');
    }).on('mouseleave',function(){
        $(this).removeClass('hover');     
    }).on('click',function(){
        var $this = $(this);
        page = $this.data('href');
    });
    $('.temp-bg').on('click',function(){    
        if(page && o_page == page){
            window.location.href = page;
        }
        o_page = page;
    });
});
				